import { useTranslation } from 'react-i18next';

import { ResultRow, ResultSection, UncalibratedBadge } from './ResultRow';
import { clarityLevel, mptVerdict, resonanceLevel } from '../../resultCopy';

import type { DiagnosisRecord } from '../../record';

/**
 * 진단 1 — 아~ 길게 부르기(덱 p10): 호흡 지속력 · 소리 안정성 · 맑기 · 울림.
 *
 * 맑기·울림은 **점수가 아니라 정성 라벨**이다. 네이티브가 실어 보내는 건 dB와 대역
 * 에너지비 원값이고, 몇 dB가 몇 점인지는 아직 보정 전이라(resultCopy 임계값 주석) 점수로
 * 바꾸면 눈금이 바뀌는 날 이력이 통째로 거짓이 된다. 값이 없으면 라벨도 없다 —
 * "측정 준비 중"이지 0점이 아니다.
 */

export const SustainSection = ({ record }: { record: DiagnosisRecord }) => {
  const { t } = useTranslation();
  const stability = record.scores.find((s) => s.key === 'pitchStability')?.val;
  const clarity = clarityLevel(record.hnrDb);
  const resonance = resonanceLevel(record.resonanceRatio);

  return (
    <ResultSection title={t('web.result.sustain.section')}>
      <ResultRow
        label={t('web.result.sustain.breath')}
        value={t('web.result.sustain.seconds', {
          value: record.sustainSec.toFixed(1),
        })}
        note={t(`web.result.sustain.band.${mptVerdict(record.sustainSec)}`)}
      />
      <ResultRow
        label={t('web.result.sustain.stability')}
        value={
          stability == null ? null : t('web.result.score', { value: stability })
        }
      />
      <ResultRow
        label={t('web.result.sustain.clarity')}
        value={clarity ? t(`web.result.sustain.clarityLevel.${clarity}`) : null}
        note={clarity ? t('web.result.sustain.clarityNote') : null}
        badge={clarity ? <UncalibratedBadge /> : null}
      />
      <ResultRow
        label={t('web.result.sustain.resonance')}
        value={
          resonance ? t(`web.result.sustain.resonanceLevel.${resonance}`) : null
        }
        note={resonance ? t('web.result.sustain.resonanceNote') : null}
        badge={resonance ? <UncalibratedBadge /> : null}
      />
    </ResultSection>
  );
};
